class ProductCardSwatches extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.#onClick);
    this.addEventListener('wheel', this.#onWheel, { passive: false });
    this.#setupArrows();
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#onClick);
    this.removeEventListener('wheel', this.#onWheel);
  }

  #onClick = (e) => {
    const arrow = e.target.closest('[data-swatches-arrow]');
    if (arrow) {
      e.preventDefault();
      e.stopPropagation();
      const track = this.querySelector('.swatches');
      if (track) {
        const step = Math.max(track.clientWidth * 0.8, 60);
        // Pas de behavior:'smooth' : certains réglages d'accessibilité
        // (mouvement réduit) l'ignorent silencieusement et rien ne défile.
        track.scrollLeft += arrow.dataset.swatchesArrow === 'next' ? step : -step;
      }
      return;
    }

    const swatch = e.target.closest('[data-href]');
    if (!swatch) return;

    e.preventDefault();
    e.stopPropagation();

    const image = swatch.dataset.image;
    const card = this.closest('product-card');
    const media = card?.querySelector('product-card-media-gallery img');

    if (!image || !media) {
      window.location.href = swatch.dataset.href;
      return;
    }

    media.removeAttribute('srcset');
    media.removeAttribute('sizes');
    media.src = image;

    this.querySelectorAll('[data-href]').forEach((el) => el.removeAttribute('aria-checked'));
    swatch.setAttribute('aria-checked', 'true');
  };

  #onWheel = (e) => {
    const track = this.querySelector('.swatches');
    if (!track || track.scrollWidth <= track.clientWidth) return;
    if (Math.abs(e.deltaY) <= Math.abs(e.deltaX)) return;
    e.preventDefault();
    track.scrollLeft += e.deltaY;
  };

  // Ajoute deux flèches cliquables de part et d'autre des pastilles quand
  // il y en a trop pour tenir dans le cadre. Le survol tactile (mobile) et
  // la molette (#onWheel) restent aussi utilisables.
  #setupArrows() {
    const track = this.querySelector('.swatches');
    if (!track) return;

    requestAnimationFrame(() => {
      if (track.scrollWidth <= track.clientWidth) return;
      if (this.querySelector('[data-swatches-arrow]')) return;

      const prev = document.createElement('button');
      prev.type = 'button';
      prev.className = 'swatches-arrow swatches-arrow--prev';
      prev.dataset.swatchesArrow = 'prev';
      prev.setAttribute('aria-label', 'Voir les couleurs précédentes');
      prev.innerHTML = '‹';

      const next = document.createElement('button');
      next.type = 'button';
      next.className = 'swatches-arrow swatches-arrow--next';
      next.dataset.swatchesArrow = 'next';
      next.setAttribute('aria-label', 'Voir les couleurs suivantes');
      next.innerHTML = '›';

      this.prepend(prev);
      this.append(next);
      this.classList.add('has-swatches-arrows');
    });
  }
}

if (!customElements.get('product-card-swatches')) {
  customElements.define('product-card-swatches', ProductCardSwatches);
}
